import Immutable from 'seamless-immutable';
// --- external imports -----

import { getNewEmptyBalanceSheetObj } from '~/models/balance-sheet';
import {  turnSelectors } from '~/store';
// ---- internal imports ----

import { getFinancialStatementsFor, getSystemFinancialStatementsFor } from './';
// ---- local imports ----


function getAccountReceivables(state) {
	return state.financialStatements.accountReceivables;
}

export function getAccountReceivablesForNextMonth(state) {
	const date = new Date(turnSelectors.getTurnDate(state));
	const year = date.getFullYear();
	const month = date.getMonth() + 1;

	const accountReceviablesForYear = getAccountReceivables(state)[year] ?? null;

	if (!accountReceviablesForYear) {
		return 0;
	}

	return accountReceviablesForYear[month + 1] ?? 0;
}

export function getAccountReceivablesAfter(state, date = null) {

	if(date === null) {
		 date = new Date(turnSelectors.getTurnDate(state));
	}

	let accountReceivablesAfterDate = 0;
	const accountReceivables = getAccountReceivables(state);

	for (const [year, months] of Object.entries(accountReceivables)) {
		if (parseInt(year) < date.getFullYear()) {
			continue;
		}

		if (parseInt(year) === date.getFullYear()) {
			accountReceivablesAfterDate += Object.entries(months).reduce(
				(total, [month, val]) => (total += month > date.getMonth() + 1 ? val : 0)
				, 0
			);
			continue;
		}

		accountReceivablesAfterDate += Object.entries(months).reduce(
			(total, [month, val]) => (total += val)
			, 0
		);
	}

	return accountReceivablesAfterDate;
}

export function getBalanceSheetFor(state, quarterNum) {
	const financialStatement = getFinancialStatementsFor(state, quarterNum);
	if (financialStatement && financialStatement.balanceSheet) {
		return financialStatement.balanceSheet;
	}
	else {
		return new Immutable(getNewEmptyBalanceSheetObj());
	}
}

export function getSystemBalanceSheetFor(state, quarterNum) {
	const financialStatement = getSystemFinancialStatementsFor(state, quarterNum);
	if (financialStatement && financialStatement.balanceSheet) {
		return financialStatement.balanceSheet;
	}
}

export function getAccountReceivablesForCurrMonth(state) {
	const currentDate = new Date(turnSelectors.getTurnDate(state));
	const month = currentDate.getMonth() + 1;
	const year = currentDate.getFullYear();
	const accountReceivablesByYear = state.financialStatements.accountReceivables[year] ?? {};
	return accountReceivablesByYear[month] ?? 0;
}

export function getAccountReceivablesForQuarter(state, quarter) {
	const { endDate } = quarter;
	return getAccountReceivablesAfter(state, endDate);
}
